import { cn } from '@/utilities/ui'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const variants = cva(
  ['font-heading', 'font-weight-heading', 'leading-heading', 'tracking-heading', 'text-balance'],
  {
    defaultVariants: {
      responsive: true,
    },
    variants: {
      size: {
        xl: '',
        h1: '',
        h2: '',
        h3: '',
        h4: '',
        h5: '',
        h6: '',
      },
      responsive: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      // responsive sizes
      { responsive: true, size: 'xl', className: 'text-heading-h3 md:text-heading-xl' },
      { responsive: true, size: 'h1', className: 'text-heading-h3 md:text-heading-h1' },
      { responsive: true, size: 'h2', className: 'text-heading-h3 md:text-heading-h2' },
      { responsive: true, size: 'h3', className: 'text-heading-h4 md:text-heading-h3' },
      { responsive: true, size: 'h4', className: 'text-heading-h4' },
      { responsive: true, size: 'h5', className: 'text-heading-h5' },
      { responsive: true, size: 'h6', className: 'text-heading-h6' },
      // non-responsive sizes
      { responsive: false, size: 'xl', className: 'text-heading-xl' },
      { responsive: false, size: 'h1', className: 'text-heading-h1' },
      { responsive: false, size: 'h2', className: 'text-heading-h2' },
      { responsive: false, size: 'h3', className: 'text-heading-h3' },
      { responsive: false, size: 'h4', className: 'text-heading-h4' },
      { responsive: false, size: 'h5', className: 'text-heading-h5' },
      { responsive: false, size: 'h6', className: 'text-heading-h6' },
    ],
  },
)

const Heading: React.FC<
  {
    ref?: React.Ref<HTMLHeadingElement>
    asChild?: boolean
  } & React.HTMLAttributes<HTMLHeadingElement> &
    VariantProps<typeof variants>
> = ({ size, responsive, className, ref, asChild, ...props }) => {
  const Comp = asChild ? Slot : size === 'xl' ? 'h1' : size || 'h1'
  return <Comp className={cn(variants({ size, responsive, className }))} ref={ref} {...props} />
}

export { Heading }
